import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { InteriorDoors } from 'landings/interior-doors';
import { RemoteProps } from './widgets-types';

export const InteriorDoorsRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <InteriorDoors />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
